import { IconTextCell } from 'common/components/ConfigurableTable/Components/Cells/IconTextCell';
import ConfigurationIcon from 'assets/images/configuration.svg';
import PendingIcon from 'assets/images/pending.svg';
import { Tooltip } from 'common/components/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { pxToRem } from 'src/common/utils/fonts';

const CustomConfigurationIcon = () => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('rSimInventory.customConfigurationDetected')}>
      <ConfigurationIcon
        width={pxToRem(16)}
        height={pxToRem(16)}
        role="img"
        data-testid="custom-configuration-icon"
      />
    </Tooltip>
  );
};

const PendingConfigurationIcon = () => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('rSimInventory.configurationChangePending')}>
      <PendingIcon
        width={pxToRem(18)}
        height={pxToRem(18)}
        role="img"
        data-testid="change-pending-icon"
      />
    </Tooltip>
  );
};

const CustomAndPendingConfiguration = () => {
  return (
    <>
      <CustomConfigurationIcon />
      <PendingConfigurationIcon />
    </>
  );
};

export const OtaCell = ({ value, subValue, row }: any) => {
  let icon;
  const { isCustomConfigurationDetected, isPendingConfiguration } = row;
  if (isCustomConfigurationDetected && isPendingConfiguration) {
    icon = <CustomAndPendingConfiguration />;
  } else if (isCustomConfigurationDetected) {
    icon = <CustomConfigurationIcon />;
  } else if (isPendingConfiguration) {
    icon = <PendingConfigurationIcon />;
  }

  return <IconTextCell value={value} subValue={subValue} icon={icon} />;
};
